import { inject, injectable } from "inversify";
import { CSATGatewayHandlers } from "../ports/CSATHandler";
import { ISalvarAvaliacaoCSATGateway } from "../ports/SalvarAvaliacaoCSATGateway";
import { AbstractCSATGatewayHandler } from "./AbstractCSATGatewayHandler";
import type {
  ISalvarAvaliacaoCSATMinhasEmpresasGateway,
  SalvarAvaliacaoMinhasEmpresasParams
} from "../ports/SalvarAvaliacaoCSATMinhasEmpresasGateway";
import { SalvarAvaliacaoCSATMinhasEmpresasGateway } from "../adapters/SalvarAvaliacaoCSATMinhasEmpresasGateway";

@injectable()
export class CSATMinhasEmpresasGatewayHandler extends AbstractCSATGatewayHandler<SalvarAvaliacaoMinhasEmpresasParams> {
  @inject(SalvarAvaliacaoCSATMinhasEmpresasGateway)
  private readonly gateway!: ISalvarAvaliacaoCSATMinhasEmpresasGateway;

  handle(
    tipo: CSATGatewayHandlers
  ): ISalvarAvaliacaoCSATGateway<unknown> | null {
    if (tipo === CSATGatewayHandlers.minhasEmpresas) {
      return this.gateway;
    }

    return super.handle(tipo);
  }
}
